import React from "react";
import { ProgressDocument } from "@cs/lib/models/progress.model";
import { UpdateChapterStateAction, UpdateQuizAction } from "./actions";

type ProgressActions = UpdateQuizAction | UpdateChapterStateAction

export type UpdateProgressType = (arg: ProgressActions) => Promise<void>
interface ProgressContextData {
  progress: ProgressDocument,
  updateProgress: UpdateProgressType
}
export const ProgressContext = React.createContext<ProgressContextData>({
  progress: {},
  updateProgress: () => Promise.resolve()
})